// -----------------------------------------------------------------
// JavaScript for Common Grid Editor functions
// -----------------------------------------------------------------

TECL_GridEditorsCommon = {

    // Initialise grid editor widget specific scripts
    Initialise: function() {
        TECL_MiniBasket.Initialise();
        TECL_NLSignup.Initialise();
    }

};